import { VApplication } from "../../application";
import { getAgent } from "./agent";

export class MyPayoutPageService {
  private static instance: MyPayoutPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): MyPayoutPageService {
    if (!MyPayoutPageService.instance) {
      MyPayoutPageService.instance = new MyPayoutPageService(props);
    }
    return MyPayoutPageService.instance;
  }

  // Get static page content (sync)
  public getStaticPageContent() {
    const agent = getAgent();
    return agent.getStaticPageContentSync({}) || {};
  }

  // ✅ Get page content (async, accepts args)
  public async getPageContent(args?: any) {
    let content: any = {};
    const agent = getAgent();

    // Header
    const headerProps = await agent.getHeaderProps(args);
    if (headerProps) content = { ...content, ...headerProps };

    // Feature Section (including bank details)
    const featureProps = await agent.getFeatureSectionProps(args);
    if (featureProps) content = { ...content, ...featureProps };

    // Footer
    const footerProps = await agent.getFooterProps(args);
    if (footerProps) content = { ...content, ...footerProps };

    return content;
  }

  public async updateBankDetail(args: any) {
    const agent = getAgent();
    return agent?.getUpdateBankDetail(args);
  }

  public async saveBankAccount(args: any) {
    const agent = getAgent();
    return agent?.saveBankAccount(args);
  }

  public formatTimeLineDetail(args: any) {
    const agent = getAgent();
    return agent.getFormatTimelineDetailSync(args);
  }
}
